import { render, staticRenderFns } from "./SalesTotalSalesComparisonByPeriodBarChart.vue?vue&type=template&id=3c2f4ccd"
import script from "./SalesTotalSalesComparisonByPeriodBarChart.vue?vue&type=script&lang=ts"
export * from "./SalesTotalSalesComparisonByPeriodBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports